import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import JoditEditor from 'jodit-react';
import { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '../Tooltip';
import InfoIcon from '../../assets/icons/info.svg';
const RichTextEditor = forwardRef(({ label, placeholder, onChange, value, additionalContent, tooltipContent, errorBorder, error, errorMessage, disabled, id, isDataReady, }, ref) => {
    const { i18n } = useTranslation();
    const config = useMemo(() => ({
        readonly: disabled,
        placeholder: placeholder,
        buttons: ['bold', 'italic', 'underline', 'ul', 'ol', 'link', 'eraser'],
        buttonsXS: ['bold', 'italic', 'underline', 'ul', 'ol', 'link', 'eraser'],
        buttonsSM: ['bold', 'italic', 'underline', 'ul', 'ol', 'link', 'eraser'],
        buttonsMD: ['bold', 'italic', 'underline', 'ul', 'ol', 'link', 'eraser'],
        buttonsLG: ['bold', 'italic', 'underline', 'ul', 'ol', 'link', 'eraser'],
        language: i18n.language === 'cs' ? 'cs_cz' : i18n.language,
        minHeight: 180,
        addNewLine: false,
        allowTabNavigation: true,
        saveSelectionOnBlur: true,
    }), [placeholder, disabled, i18n.language]);
    return (_jsxs("div", { className: "input-item", children: [!!label && (_jsxs("div", { className: "label", children: [label, tooltipContent && (_jsx(Tooltip, { content: tooltipContent, position: "top", children: _jsx(InfoIcon, { style: {
                                width: '16px',
                                height: '16px',
                                marginLeft: '4px',
                                cursor: 'help',
                                display: 'inline-block',
                                verticalAlign: 'middle',
                            } }) }))] })), _jsxs("div", { className: `input-wrapper${error || errorBorder ? ' jodit-field-error' : ''}`, children: [isDataReady && (_jsx(JoditEditor, { ref: ref, value: value, config: config, onChange: onChange, tabIndex: 1 }, id)), !!additionalContent && (_jsx("div", { className: 'input-additional-content', children: additionalContent })), error && errorMessage && _jsx("div", { className: "form-field-error-message", children: errorMessage })] })] }));
});
export default RichTextEditor;
